import { normalizeDefinitions } from './normalize.js';

let modules = [];
if (process.env.NODE_ENV !== 'test') {
  const context = require.context('../optional-modules', true, /\/module\.jsx$/);
  modules = context.keys().map(context);
}
export const installedModules = normalizeDefinitions(modules);
